import React, { useState } from "react";
import { useSiteData } from "../context/SiteDataContext";

const Contact: React.FC = () => {
  const { data } = useSiteData();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState<"idle" | "sending" | "success" | "error">("idle");
  const [statusMsg, setStatusMsg] = useState("");

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus("sending");
    setStatusMsg("");
    try {
      const res = await fetch(`${window.location.origin}/messages.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...formData,
          website: "",
        }),
      });
      const data = await res.json();
      if (res.ok && data.ok) {
        setStatus("success");
        setStatusMsg(data.message || "Mesajınız alındı.");
        setFormData({ name: "", email: "", phone: "", subject: "", message: "" });
      } else {
        setStatus("error");
        setStatusMsg(data.error || "Bir hata oluştu.");
      }
    } catch {
      setStatus("error");
      setStatusMsg("Bağlantı hatası. Lütfen tekrar deneyin.");
    }
  };

  return (
    <>
      <div className="page-header">
        <div className="container">
          <h1>İletişim</h1>
          <p>Projeleriniz için benimle iletişime geçebilirsiniz</p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h3>Bana Ulaşın</h3>

              <div className="contact-item">
                <div className="contact-icon">📞</div>
                <div>
                  <h4>Telefon</h4>
                  <p>{data.contact.phone}</p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">📧</div>
                <div>
                  <h4>E-posta</h4>
                  <p>{data.contact.email}</p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <div>
                  <h4>Konum</h4>
                  <p>{data.contact.location}</p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">⏰</div>
                <div>
                  <h4>Çalışma Saatleri</h4>
                  <p>{data.contact.workingHours}</p>
                </div>
              </div>
            </div>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Adınız Soyadınız</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Adınızı girin"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">E-posta Adresiniz</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="E-posta adresinizi girin"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Telefon Numaranız</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="05XX XXX XX XX"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Konu</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Web Tasarım / Sesli Yazıya Çeviri / Canlı Altyazı"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Mesajınız</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Projeniz hakkında detayları yazın"
                  required
                />
              </div>

              <button type="submit" className="btn-primary" style={{ width: "100%" }} disabled={status === "sending"}>
                {status === "sending" ? "Gönderiliyor..." : "Mesaj Gönder"}
              </button>

              {status === "success" && (
                <div style={{ marginTop: "16px", padding: "14px 16px", background: "#dcfce7", color: "#166534", borderRadius: "8px", fontSize: "0.95rem" }}>
                  ✅ {statusMsg}
                </div>
              )}
              {status === "error" && (
                <div style={{ marginTop: "16px", padding: "14px 16px", background: "#fee2e2", color: "#991b1b", borderRadius: "8px", fontSize: "0.95rem" }}>
                  ❌ {statusMsg}
                </div>
              )}
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
